// @flow
import * as React from 'react';

import { useToast, ToastTypes } from 'common/components/core/toast';
import useEffectOnce from 'common/hooks/useEffectOnce';

import useAccessDeniedMessage from './useAccessDeniedMessage';

type Props = {
    action: string
};

const AccessDeniedToast = ({ action }: Props): React.Node => {
    const { showToast } = useToast();
    const msg = useAccessDeniedMessage({ action });

    useEffectOnce(() => {
        showToast({
            message: msg,
            type: ToastTypes.Error
        });
    });

    return null;
};

export default AccessDeniedToast;
